"use client";
// npm packages
import classNames from "classnames";
import React, { useEffect, useState, useRef, useCallback } from "react";

// components
import Text from "../Text";
import Icon from "../Icon";

const NotificationOnModal = ({ data, onView, onClose }) => {
  const modalRef = useRef(null);
  const [openModal, setOpenModal] = useState(onView);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
        // document.body.style.overflow = "hidden";
      }, 100);
    } else {
      setOpenModal(false);
      document.body.style.overflow = "";
    };

    return () => {
      document.body.style.overflow = "";
    };
  }, [onView]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      };
    };

    if (openModal) {
      document.addEventListener("mousedown", handleOutsideClick);
    };

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openModal]);

  const handleClose = useCallback((closeState, data) => {
    setOpenModal(closeState);
    onClose(closeState, data);
  }, [onClose]);


  useEffect(() => {
    if (onView) {
      const timer = setTimeout(() => {
        handleClose(false, false);
      }, 5000);

      return () => clearTimeout(timer);
    };
  }, [onView, handleClose]);

  return (
    <div
      className={classNames(
        "w-[100vw] h-full bg-transparent flex items-end justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0",
        { "!opacity-100 !z-[501]": openModal }
      )}
    >
      <div
        ref={modalRef}
        className="w-full lg:max-w-[720px] bg-cape-verde flex items-center justify-between gap-[6px] lg:gap-[16px] mx-8 lg:mx-0 mb-10 lg:mb-40 pr-6 pl-16 lg:pl-32 lg:pr-16 py-12 lg:py-16 rounded-[4px] transition-all duration-[400ms] shadow-cannot-be-added-modal"
      >
        <Text
          type="paragraph"
          className="!text-white text-14 lg:text-18 font-encode-sans font-medium leading-20 lg:leading-28 tracking-[0.28px] lg:tracking-[0.36px]"
        >
          {data}
        </Text>
        <Icon
          type="close"
          color="#fff"
          className="cursor-pointer min-w-[24px]"
          onClick={handleClose}
        />
      </div>
    </div>
  );
};

export default NotificationOnModal;